export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 clients: {"default": {"defaultOptions": {"query": {"fetchPolicy": "no-cache"}}, "httpEndpoint": () => useRuntimeConfig().public.GQL_HOST || 'https://localhost:4443/graphql', "httpLinkOptions": {"credentials": "include", "fetch": (uri, options = {}) => {
            const match = document.cookie.match(/(?:^|; )csrfToken=([^;]*)/);
            const csrf = match ? decodeURIComponent(match[1]) : "";

            const headers = new Headers(options.headers);
            headers.set("x-csrf-token", csrf);

            return fetch(uri, {
              ...options,
              headers
            });
          }}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie"}, "webSocketClient": {"wsEndpoint": () => useRuntimeConfig().public.WS_HOST || '', "wsLinkOptions": {"credentials": "include"}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:webSocketClient.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}